import SelectSendersAndReceivers from '../select-senders-and-receivers/select-senders-and-receivers.component';

const SelectSendersAndReceiversWithProofOfIdentity = (props: { wizard_id: string }) => (
    <SelectSendersAndReceivers
        wizard_id={props.wizard_id}
        requireProofOfIdentity
    />
);

export default SelectSendersAndReceiversWithProofOfIdentity;
